import React from "react";

function TokenListingHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-9.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Get Your Token Recognized on Leading Platforms
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    End-to-end token listing services that streamline your
                    project’s entry into the global market.
                  </p>
                  <div className="button mt-30 fade-up-anim">
                    <a href="#" className="btn btn-style-one light">
                      Join Today
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="banner-two-right-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/thumb/1.jpg"
                    alt="Image Not Found"
                  />
                </div>
                <div className="top-info fade-up-anim" data-wow-delay="100ms">
                  <h4>Handle everything in quick &amp; instant</h4>
                  <h5>500+ Reviews</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TokenListingHero;
